/** Which screen edge the sidepanel is anchored to. */
export type SidepanelSide = 'left' | 'right'

/** All anchorable screen edges, for consumers that enumerate them (e.g. drop zones). */
export const SIDEPANEL_SIDES: ReadonlyArray<SidepanelSide> = ['left', 'right']

export const SIDEPANEL_SIDE_SETTING_KEY = 'sidepanel.side'
export const DEFAULT_SIDEPANEL_SIDE: SidepanelSide = 'right'

export const isSidepanelSide = (value: unknown): value is SidepanelSide => value === 'left' || value === 'right'

/** Validates a persisted/untrusted value, falling back to the default side. */
export const resolveSidepanelSide = (value: unknown): SidepanelSide =>
  isSidepanelSide(value) ? value : DEFAULT_SIDEPANEL_SIDE

/** The opposite screen edge — the panel's inner edge, facing the rest of the screen. */
export const oppositeSide = (side: SidepanelSide): SidepanelSide => (side === 'right' ? 'left' : 'right')

/** React style key for padding against the given screen edge. */
export const sidePaddingProp = (side: SidepanelSide): 'paddingLeft' | 'paddingRight' =>
  side === 'right' ? 'paddingRight' : 'paddingLeft'

/** +1 when anchored right, -1 when anchored left — multiplies x offsets/deltas that point "toward the edge". */
export const sidepanelSideSign = (side: SidepanelSide): 1 | -1 => (side === 'right' ? 1 : -1)
